export default "__VITE_ASSET__BhjTl8qz__"